import { useContext } from 'react'
import { XRayContext, type XRayContextValue } from './xrayContext'

export const useXRay = (): XRayContextValue => {
  const context = useContext(XRayContext)
  if (!context) {
    throw new Error('useXRay must be used within an XRayProvider')
  }
  return context
}
